import React, { forwardRef, useEffect, useState } from 'react';
import '@react-pdf-viewer/search/lib/styles/index.css';

const SearchBar = forwardRef(({ searchPluginInstance, showSearchBar, onSearch, onNextMatch, onPreviousMatch }, ref) => {
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    if (showSearchBar && ref && ref.current) {
      ref.current.focus();
    }
  }, [showSearchBar, ref]);

  const handleSearch = () => {
    const trimmedKeyword = keyword.trim();
    if (trimmedKeyword !== '') {
      onSearch(trimmedKeyword);
      setSearchPerformed(true);
    } else {
      clearSearch();
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setKeyword(newValue);
    if (newValue.trim() === '') {
      clearSearch();
    }
  };

  const clearSearch = () => {
    setKeyword('');
    setSearchPerformed(false);
    onSearch(null); // This will pass null to the parent component
    if (ref.current) {
      ref.current.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      clearSearch();
    }
  };

  return (
    showSearchBar && (
      <div className="search-bar">
        <div className="searchContainer" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Enter text to search"
            value={keyword}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            ref={ref}
            className={keyword === '' ? 'highlighted-off' : ''}
            style={{ 
              paddingRight: '30px', // Make room for the X button
              flex: 1
            }}
          />
          {keyword && (
            <button
              onClick={clearSearch}
              style={{
                position: 'absolute',
                right: '100px', // Position before the search button
                background: 'none',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#666',
                padding: '4px 8px',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title="Clear search"
              type="button"
            >
              ×
            </button>
          )}
          <button
            style={{
              color: 'white',
              backgroundColor: '#165bc3',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500',
              marginLeft: '8px'
            }}
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
        {searchPerformed && (
          <div className="nextTap">
            <button
              onClick={onPreviousMatch}
              style={{ color: 'rgb(22, 91, 195)' }}
            >
              &#9650; {/* Up arrow */}
            </button>
            <button
              onClick={onNextMatch}
              style={{ color: 'rgb(22, 91, 195)' }}
            >
              &#9660; {/* Down arrow */}
            </button>
          </div>
        )}
      </div>
    )
  );
});

export default SearchBar;